import { lightColorPalette } from '@linearb/linui-common';
import { cssWhiteSection, STICKY_OFFSET } from 'components/base/common-styles';
import styled from 'styled-components';
import { StyledFilters } from './Filters/Filters.style';

export const StyledProjectsFiltersBar = styled.header`
  ${cssWhiteSection};
  min-height: 10vh;
  position: sticky;
  top: -${STICKY_OFFSET}rem;
  z-index: 999;
  border-bottom: 1rem solid ${lightColorPalette.lbBlue_10};
  display: flex;
  align-items: flex-start;
  align-items: center;
  width: 100%;

  & ${StyledFilters} {
    width: 100%;
  }
`;
